import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Grid, Divider, Switch, LinearProgress, Button } from '@material-ui/core';
import { Breadcrumb, BackdropCircular } from 'components';
import { getStoreConfigsApi, updateStoreConfigsApi } from 'api';
import { changeStoreConfig } from 'redux/actions/store_configs';


export default function WishlistConf() {
  const dispatch = useDispatch();

  useEffect(() => {
    getStoreConfigsApi({dispatch});
  }, []);

  const {storeConfigs, loading, error} = useSelector((state) => state.store_configs);

  const handleChange = (event) => {
    const {checked, name, type, value} = event.target;
    dispatch(changeStoreConfig(name, checked, type, value));
  };

  const handleSave = () => {
    const configs = storeConfigs.filter((config) => config.path === 'wishlist/general/active');
    updateStoreConfigsApi({dispatch, configs});
  };

  return (
    <div className="flex-grow flex-column relative h-full scroll-y">
      <div>
        <Breadcrumb
          routeSegments={[
            { name: 'Settings', path: '/settings#go_live_requirements' },
            { name: 'Store Configurations', path: '/settings#store_configurations' },
            { name: 'Wishlist' }
          ]}
        />
      </div>
      <div className="mt-10 mx-10">
        <Card className="p-8">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <p className="text-gray">In this section you can allow or disallow customers add products into wishlist on your store</p>
            </Grid>
            <Grid item xs={12}>
              <Divider />
            </Grid>
            {loading && <LinearProgress className="m-10" />}
            {!loading && !error &&
            <>
              <Grid item xs={6}>
                Enable Adding Products to Wish List:
              </Grid>
              <Grid item xs={6}>
                <Switch
                  color="primary"
                  name="wishlist/general/active"
                  checked={storeConfigs.find((config) => config.path === 'wishlist/general/active')?.value == 1}
                  onChange={handleChange}
                />
              </Grid>
            </>
            }
          </Grid>
        </Card>
        <div className="flex justify-end">
          <Button variant="contained" color="primary" className="my-10" onClick={handleSave}>Save Configurations</Button>
          <BackdropCircular loading={loading} />
        </div>
      </div>
    </div>
  );
}
